<div *ngIf="loading | async" class="click-blocker"></div>

<router-outlet></router-outlet>
